/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class SsoSamlLoginService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Initiate a login request.
     * @returns void
     * @throws ApiError
     */
    public saml2LoginRedirect({
        uuid,
        returnTo
    }: {
        /**
         * UUID of the retrieved resource.
         */
        uuid: string
        /**
         * URL to redirect to after login
         */
        returnTo?: string
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/saml2/{uuid}/login',
            path: {
                uuid: uuid
            },
            query: {
                returnTo: returnTo
            },
            errors: {
                302: `Redirect to IdP login page`,
                404: `Not Found`
            }
        })
    }

    /**
     * Render the metadata.
     * @returns any OK
     * @throws ApiError
     */
    public saml2Metadata({
        uuid
    }: {
        /**
         * UUID of the retrieved resource.
         */
        uuid: string
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/saml2/{uuid}/metadata',
            path: {
                uuid: uuid
            },
            errors: {
                404: `Not Found`
            }
        })
    }
}
